import EmailPresetFormPage from "./emailPresetFormPage";

const CreateEmailPreset = () => <EmailPresetFormPage mode="create" />;

export default CreateEmailPreset;
